import { GameVars } from "./GameVars";
import { GameConstants } from "./GameConstants";
import { GameManager } from "./GameManager";

export class Boot extends Phaser.State {

    public static currentInstance: Boot;

    public init(): void {

        Boot.currentInstance = this;
    }
    
    public create(): void {

        //  Unless you specifically need to support multitouch I would recommend setting this to 1
        this.input.maxPointers = 1;

        this.game.stage.disableVisibilityChange = true;

        // por el problema del stock browser
        this.game.stage.backgroundColor =  "#000000";

        GameVars.scaleY = 1;
        GameVars.fieldCorrectionScaleY = 1;
        
        this.game.scale.scaleMode = Phaser.ScaleManager.SHOW_ALL;
        this.game.scale.pageAlignHorizontally = true;

        this.game.renderer.clearBeforeRender = false;

        if (GameConstants.DEVELOPMENT) {
            this.game.time.advancedTiming = true;
        }

        this.game.physics.startSystem( Phaser.Physics.P2JS );
        this.game.physics.p2.gravity.y = 1300;
        this.game.physics.p2.setBoundsToWorld( false, false, false , false);

        GameVars.getInstance().init(this.game);            
        GameManager.init(this.game);
    }
}
